import BulkStockImport from './BulkStockImport';

export default BulkStockImport;
